export default __webpack_public_path__ + "media/images/rabbit_ui_announce-eb4f43ca2c8fe572dc0d1f32a6dd8333.png";